import React from "react";
import "../App.css"; // CSS file for styling

const TextGifSection = () => {
  return (
    <div className="text-gif-container">
      <div className="text-section">
        <h2 className="text-title">Retain Top Talent</h2>
        <p className="text-description">
        Recruiters lose <strong>53% of qualified candidates</strong> due to communication gaps.  
    Chronoflow engages <strong> candidates</strong>  by updating them with  <strong>live</strong> application status and provides candidate specific <strong>feedback</strong> upon rejection for <strong>higher candidate retention.</strong>
    <br/>We help recruiters focus on what truly matters—<strong>building lasting relationships</strong> and making quality hires.
        </p>
      </div>
      <div className="gif-section">
        <img
          src="./GIF for landing page (2).gif"  // Update with the actual GIF path
          alt="Animated Hiring Process"
          className="gif-image"
        />
      </div>
    </div>
  );
};

export default TextGifSection;
